// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./routes/feiseanna/one/admin/schools/styles.scss
// module id = 1000
// module chunks = 0